import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { HeadersLoggedOut } from 'web-ui-kit/navigation';
import { primaryM } from 'web-ui-kit/colors';
import { NEXTJS_MODAL_Z_INDEX } from 'web-ui-kit/zIndexes';

export default function HeaderMonarchLoggedOut ({
  // To extend styling.
  className = 'header-webpp',

  // One of ['web-post-purchase', 'nextjs', 'wordpress']
  currentApp = 'web-post-purchase',

  // Mechanism for bubbling events up.
  dispatch = () => {},

  // Used to register height and add spacing to UI elements
  headerID = '',

  // Used to position the drawer menu under the optional top banners.
  topDrawerPosition = '3rem'
}) {
  function LinkComponent ({
    children,
    route = {},
    styledLink
  } = {}) {
    const StyledLink = styledLink;
    if (route.app === 'web-post-purchase') {
      return (
        <ReactRouterLink to={route.destination}>{children}</ReactRouterLink>
      );
    }

    return (
      <StyledLink href={route.destination}>{children}</StyledLink>
    );
  }

  return (
    <HeaderLoggedOut
      dispatch={dispatch}
      className={className}
      currentApp={currentApp}
      linkComponent={LinkComponent}
      headerID={headerID}
      topDrawerPosition={topDrawerPosition}
    />
  );
}

const HeaderLoggedOut = styled(HeadersLoggedOut)`
  &.header-webpp {
    z-index: ${NEXTJS_MODAL_Z_INDEX + 1};
  }
`;

const ReactRouterLink = styled(Link)`
  text-decoration: none;
  height: 100%;
  color: ${primaryM};
`;
